/**
 * Strip known-PII fields from GraphQL operation variables before forwarding
 * them to Datadog. Everything else is passed through as-is — this is an
 * exclusion list, not an allowlist, so new business fields become visible in
 * error reports automatically. Add to `PII_FIELDS` if a new sensitive field
 * name enters the schema.
 */

const PII_FIELDS = new Set([
	'email',
	'phone',
	'phoneNumber',
	'mobile',
	'fullName',
	'firstName',
	'lastName',
	'password',
	'token',
	'accessToken',
	'refreshToken',
	'idToken',
]);

const sanitizeValue = (value) => {
	if (Array.isArray(value)) return value.map(sanitizeValue);
	if (value && typeof value === 'object') return sanitize(value);
	return value;
};

const sanitize = (input) => {
	if (!input || typeof input !== 'object') return input;
	const result = {};
	for (const [key, value] of Object.entries(input)) {
		if (PII_FIELDS.has(key)) continue;
		result[key] = sanitizeValue(value);
	}
	return result;
};

export const sanitizeVariables = (variables) => sanitize(variables);
